import { createApp } from 'vue'
import store from '@/store'
import App from '@/App.vue'
import vClickOutside from 'click-outside-vue3'
import getRouter from './router'
import { RecycleScroller } from 'vue-virtual-scroller' // Documentation: https://github.com/Akryum/vue-virtual-scroller/tree/master/packages/vue-virtual-scroller

import '@/style/index.scss'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import setWindowTitle from '@/utils/setWindowTitle'

import i18n from '@/lang'
import ElementPlus from 'element-plus'
import VueSSE from 'vue-sse'
import { vMaska } from 'maska'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'

import globalWarning from '@/mixins/globalWarning'
import notification from '@/mixins/notification'
import installPermissions from './permission'
import VueCookies from 'vue-cookies'

library.add(fas, far)

async function initApp() {
  const app = createApp(App)
  const router = await getRouter()

  app.component('RecycleScroller', RecycleScroller)
  app.component('FontAwesomeIcon', FontAwesomeIcon)

  app.directive('maska', vMaska)

  installPermissions(app)

  app.mixin({
    computed: {
      debug() {
        return import.meta.env.DEV
      }
    },
    methods: {
      ...globalWarning.methods,
      ...notification.methods
    }
  })

  store.dispatch('initialize')

  app.use(vClickOutside)
  app.use(store)
  app.use(router)
  app.use(i18n)
  app.use(ElementPlus)
  app.use(VueSSE)
  app.mount('#app')
}

initApp()
